<div class="h-100" [ngStyle]="margin">
  <div class="spinner-container">
    <div class="spinner" [ngStyle]="spinnerSize"></div>
    <img [src]="this.logoUrl" alt="loader" class="d-block mx-auto my-5 logo-image" [ngStyle]="size" />
  </div>
</div>
